import { useIntl } from "react-intl";
import cn from "classnames";
import styles from "./LocationSelector.module.scss";
import { useLocationSelectorControl } from "./useLocationSelectorControl";
import { ILocationSelectorProps } from "./LocationSelector.props";
import CommonSelector from "../CommonSelector/CommonSelector";

export default function LocationSelector({ ...props }: ILocationSelectorProps) {
  const { formatMessage } = useIntl();

  const control = useLocationSelectorControl(props);

  return (
    <CommonSelector
      showSearch
      id={props.id}
      hasPrevText={props.showPrev}
      hasCleanUp={props.hasCleanUp}
      name={props.name}
      options={control.locations.map((u) => ({
        id: u.id,
        text: `${u.location_id} ${u.name}`,
      }))}
      currentValue={
        control.currentValue && {
          id: control.currentValue.id,
          text: `${control.currentValue.location_id} ${control.currentValue.name}`,
        }
      }
      onCleanUp={props.onClearClick}
      onChange={control.onGetLocation}
      clearedValue={props.hasDefaultValue ? control.CLEARED_VALUE : undefined}
    />
  );
}
